const actions = {
  // API Keys Actions
  GET_API_KEYS: 'RBAC/API_KEYS/GET_API_KEYS',
  GET_API_KEYS_SUCCESS: 'RBAC/API_KEYS/GET_API_KEYS_SUCCESS',
  GET_API_KEYS_ERROR: 'RBAC/API_KEYS/GET_API_KEYS_ERROR',
  CREATE_API_KEY: 'RBAC/API_KEYS/CREATE_API_KEY',
  CREATE_API_KEY_SUCCESS: 'RBAC/API_KEYS/CREATE_API_KEY_SUCCESS',
  CREATE_API_KEY_ERROR: 'RBAC/API_KEYS/CREATE_API_KEY_ERROR',
  UPDATE_API_KEY: 'RBAC/API_KEYS/UPDATE_API_KEY',
  UPDATE_API_KEY_SUCCESS: 'RBAC/API_KEYS/UPDATE_API_KEY_SUCCESS',
  UPDATE_API_KEY_ERROR: 'RBAC/API_KEYS/UPDATE_API_KEY_ERROR',
  DELETE_API_KEY: 'RBAC/API_KEYS/DELETE_API_KEY',
  DELETE_API_KEY_SUCCESS: 'RBAC/API_KEYS/DELETE_API_KEY_SUCCESS',
  DELETE_API_KEY_ERROR: 'RBAC/API_KEYS/DELETE_API_KEY_ERROR',
  REGENERATE_API_KEY: 'RBAC/API_KEYS/REGENERATE_API_KEY',
  REGENERATE_API_KEY_SUCCESS: 'RBAC/API_KEYS/REGENERATE_API_KEY_SUCCESS',
  REGENERATE_API_KEY_ERROR: 'RBAC/API_KEYS/REGENERATE_API_KEY_ERROR',
  CLEAR_API_KEYS_ERROR: 'RBAC/API_KEYS/CLEAR_API_KEYS_ERROR',

  // Action Creators
  getApiKeys: (options = {}) => ({
    type: actions.GET_API_KEYS,
    options,
  }),
  getApiKeysSuccess: (apiKeys, total) => ({
    type: actions.GET_API_KEYS_SUCCESS,
    apiKeys,
    total,
  }),
  getApiKeysError: (error) => ({
    type: actions.GET_API_KEYS_ERROR,
    error,
  }),
  createApiKey: (keyData) => ({
    type: actions.CREATE_API_KEY,
    keyData,
  }),
  createApiKeySuccess: (apiKey) => ({
    type: actions.CREATE_API_KEY_SUCCESS,
    apiKey,
  }),
  createApiKeyError: (error) => ({
    type: actions.CREATE_API_KEY_ERROR,
    error,
  }),
  updateApiKey: (keyId, keyData) => ({
    type: actions.UPDATE_API_KEY,
    keyId,
    keyData,
  }),
  updateApiKeySuccess: (apiKey) => ({
    type: actions.UPDATE_API_KEY_SUCCESS,
    apiKey,
  }),
  updateApiKeyError: (error) => ({
    type: actions.UPDATE_API_KEY_ERROR,
    error,
  }),
  deleteApiKey: (keyId) => ({
    type: actions.DELETE_API_KEY,
    keyId,
  }),
  deleteApiKeySuccess: (keyId) => ({
    type: actions.DELETE_API_KEY_SUCCESS,
    keyId,
  }),
  deleteApiKeyError: (error) => ({
    type: actions.DELETE_API_KEY_ERROR,
    error,
  }),
  regenerateApiKey: (keyId) => ({
    type: actions.REGENERATE_API_KEY,
    keyId,
  }),
  regenerateApiKeySuccess: (apiKey) => ({
    type: actions.REGENERATE_API_KEY_SUCCESS,
    apiKey,
  }),
  regenerateApiKeyError: (error) => ({
    type: actions.REGENERATE_API_KEY_ERROR,
    error,
  }),
  clearApiKeysError: () => ({
    type: actions.CLEAR_API_KEYS_ERROR,
  }),
};

export default actions;
